// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__vq1BG","active":"styles_active__WCmnF","spinner":"styles_spinner__zeSHI","circle":"styles_circle__+aStF","secondary":"styles_secondary__OJE5l"};